import { render } from "./download.vue?vue&type=template&id=6de56cf2"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/download.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6de56cf2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6de56cf2', __exports__)) {
    api.reload('6de56cf2', __exports__)
  }
  
  module.hot.accept("./download.vue?vue&type=template&id=6de56cf2", () => {
    api.rerender('6de56cf2', render)
  })

}


export default __exports__